export function canQuickAudit(row) {
  return !!(row && row.type !== 'overtime' && row.id != null)
}

export function parseUserRoleId(user) {
  return Number(user?.roleId ?? user?.role_id ?? 0)
}
